import React from 'react';
import { Routes, Route, Link, Navigate, useLocation } from 'react-router-dom';
import {
    BarChart3,
    BatteryCharging,
    CalendarDays,
    FileDown,
    Fingerprint,
    MoreHorizontal,
    Zap
} from 'lucide-react';
import GestaoCard from './GestaoCard';
import ExtracaoFaturasView from './ExtracaoFaturasView';
import HistoricoExtracoesView from './Extracao/HistoricoExtracoesView';
import DatasFaturasView from './DatasFaturas/DatasFaturasView';
import DatasBoletosView from './DatasFaturas/DatasBoletosView';
import RateioLayout from './Rateio/RateioLayout';
import RateioCreditosView from './Rateio/RateioCreditosView';
import SaldosUcsView from './Rateio/SaldosUcsView';
import LemitView, { hasLemitAccess } from './LemitView';
import { useAuth } from '../../src/contexts/AuthContext';
import { ehGerenteComercial } from '../../src/lib/departamentos';
const GestaoLayout: React.FC = () => {
    const location = useLocation();
    const currentPath = location.pathname;
    const { profile } = useAuth();
    const lemitOk = hasLemitAccess(profile);
    // #6530: a gerente do Comercial entra só para consultar a Validação de Dados.
    const soValidacao = ehGerenteComercial(profile) && !profile?.permissions?.includes('modulo:gestao');

    const NavLink = ({ to, label, icon: Icon, disabled }: { to: string, label: string, icon: any, disabled?: boolean }) => {
        const base = `/gestao${to}`;
        // Checa fronteira de path (== ou +"/") pra "/rateio" não ficar ativo
        // junto com "/rateio-antigo" (startsWith puro combina os dois).
        const active = to === ''
            ? currentPath === '/gestao' || currentPath === '/gestao/'
            : currentPath === base || currentPath.startsWith(`${base}/`);

        if (disabled) {
            return (
                <div className="w-full flex items-center gap-3 px-4 py-3 text-sm font-medium rounded-xl text-gray-400 dark:text-gray-500 cursor-default opacity-70">
                    <Icon size={18} />
                    {label}
                </div>
            );
        }

        return (
            <Link
                to={`/gestao${to}`}
                className={`w-full flex items-center gap-3 px-4 py-3 text-sm font-medium rounded-xl transition-all duration-200 ${active
                    ? 'bg-primary text-white shadow-md'
                    : 'text-gray-500 hover:text-gray-900 hover:bg-gray-100 dark:text-gray-400 dark:hover:text-gray-100 dark:hover:bg-gray-800'
                    }`}
            >
                <Icon size={18} />
                {label}
            </Link>
        );
    };

    return (
        <div className="flex flex-col md:flex-row gap-6 items-start">
            {/* Sidebar - Desktop & Tablet */}
            <aside className="w-full md:w-64 flex-shrink-0">
                <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-sm border border-gray-100 dark:border-gray-700 overflow-hidden sticky top-24">
                    <div className="p-4 border-b border-gray-100 dark:border-gray-700 bg-gray-50/50 dark:bg-gray-800/50">
                        <h2 className="font-poppins font-semibold text-gray-800 dark:text-gray-200">Menu</h2>
                    </div>
                    <nav className="p-2 space-y-1">
                        <NavLink to="" label="Validação de Dados" icon={BarChart3} />
                        {!soValidacao && <>
                        <NavLink to="/extracao" label="Extração de Faturas" icon={FileDown} />
                        <NavLink to="/datas-faturas" label="Datas das Faturas" icon={CalendarDays} />
                        <NavLink to="/rateio" label="Simulador de Rateio" icon={Zap} />
                        <NavLink to="/rateio-saldos" label="Saldos das UCs" icon={BatteryCharging} />
                        <NavLink to="/rateio-antigo" label="Rateio Antigo" icon={Zap} />
                        {lemitOk && <NavLink to="/lemit" label="Central Lemit" icon={Fingerprint} />}
                        <NavLink to="#" label="Mais opções em breve" icon={MoreHorizontal} disabled />
                        </>}
                    </nav>
                </div>
            </aside>

            {/* Main Content */}
            <div className="flex-1 min-w-0 w-full animate-fade-in">
                <Routes>
                    <Route index element={<GestaoCard />} />
                    {!soValidacao && <>
                    <Route path="extracao" element={<ExtracaoFaturasView />} />
                    <Route path="extracao/historico" element={<HistoricoExtracoesView />} />
                    <Route path="datas-faturas" element={<DatasFaturasView />} />
                    <Route path="datas-faturas/boletos" element={<DatasBoletosView />} />
                    <Route path="rateio/*" element={<RateioLayout />} />
                    <Route path="rateio-antigo" element={<RateioCreditosView />} />
                    <Route path="rateio-saldos" element={<SaldosUcsView />} />
                    <Route path="lemit" element={<LemitView />} />
                    </>}
                    {soValidacao && <Route path="*" element={<Navigate to="/gestao" replace />} />}
                </Routes>
            </div>
        </div>
    );
};



export default GestaoLayout;
